(function() {
  // Check for actual touch device, not just screen width
  const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  const isMobile = window.innerWidth < 1000;
  
  if (!isTouchDevice || !isMobile) return;

  function initVideoSwipeFix() {
    const gallery = document.querySelector('.product-gallery__carousel');
    if (!gallery) return;

    const cells = gallery.querySelectorAll('.product-gallery__media');
    const videoMedias = gallery.querySelectorAll('.product-gallery__media[data-media-type="video"], .product-gallery__media[data-media-type="external_video"]');
    
    if (videoMedias.length === 0) return;

    videoMedias.forEach(function(mediaContainer) {
      const videoMedia = mediaContainer.querySelector('video-media');
      if (!videoMedia || videoMedia.dataset.swipeFixed) return;
      
      videoMedia.dataset.swipeFixed = 'true';
      
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let isHorizontalSwipe = null;
      let startTime = 0;

      videoMedia.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startScrollLeft = gallery.scrollLeft;
        startTime = Date.now();
        isHorizontalSwipe = null;
        
        // Disable scroll snap during swipe for smoother movement
        gallery.style.scrollSnapType = 'none';
      }, { passive: true });

      videoMedia.addEventListener('touchmove', function(e) {
        if (!startX) return;

        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = startX - currentX;
        const diffY = startY - currentY;

        // Determine direction on first significant movement
        if (isHorizontalSwipe === null && (Math.abs(diffX) > 8 || Math.abs(diffY) > 8)) {
          isHorizontalSwipe = Math.abs(diffX) > Math.abs(diffY);
        }

        // Horizontal swipe - scroll gallery
        if (isHorizontalSwipe) {
          e.preventDefault();
          e.stopPropagation();
          gallery.scrollLeft = startScrollLeft + diffX;
        }
      }, { passive: false });

      videoMedia.addEventListener('touchend', function(e) {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;
        const timeDiff = Date.now() - startTime;
        
        // Re-enable scroll snap
        gallery.style.scrollSnapType = '';

        // Calculate velocity for momentum
        const velocity = Math.abs(diffX) / timeDiff;

        if (isHorizontalSwipe && (Math.abs(diffX) > 50 || velocity > 0.3)) {
          // Swipe detected - snap to next/prev slide
          const cellWidth = cells[0]?.offsetWidth || gallery.offsetWidth;
          const currentIndex = Math.round(gallery.scrollLeft / cellWidth);
          const direction = diffX > 0 ? 1 : -1;
          const targetIndex = Math.max(0, Math.min(cells.length - 1, currentIndex + direction));
          
          gallery.scrollTo({
            left: targetIndex * cellWidth,
            behavior: 'smooth'
          });
        } else if (Math.abs(diffX) < 10 && Math.abs(diffY) < 10 && timeDiff < 300) {
          // It's a tap - toggle video play/pause
          const video = videoMedia.querySelector('video');
          if (video) {
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          }
        }

        // Reset
        startX = 0;
        startY = 0;
        isHorizontalSwipe = null;
      }, { passive: true });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSwipeFix);
  } else {
    initVideoSwipeFix();
  }
  
  // Re-init on variant change (in case gallery rebuilds)
  document.addEventListener('variant:changed', initVideoSwipeFix);
  
  // Fallback re-init
  setTimeout(initVideoSwipeFix, 1500);
})();